import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import classnames from 'classnames';

import s from './sliderDesc.css';

const SliderDesc = ({ leftContent, rightContent }) => (
  <div className={classnames('row', s.sliderDesc)}>
    <div className={classnames('col-6', s.textLeft)}>{leftContent}</div>
    <div className={classnames('col-6', s.textRight)}>{rightContent}</div>
  </div>
);

SliderDesc.propTypes = {
  leftContent: PropTypes.string,
  rightContent: PropTypes.string,
};
SliderDesc.defaultProps = {
  leftContent: '',
  rightContent: '',
};
export default withStyles(s)(SliderDesc);
